<template>
  <el-dropdown class="avatar-container right-menu-item hover-effect">
    <el-avatar :size="50" :src="$store.state.user.avatarUrl || defaultAvatarUrl"></el-avatar>
    <template #dropdown>
      <el-dropdown-menu style="min-width: 110px">
        <el-dropdown-item>{{$store.state.user.name}}</el-dropdown-item>
        <el-dropdown-item @click.native="resetAutoDispatch">修改密码</el-dropdown-item>
        <el-dropdown-item v-if="$store.state.user.punchInTime"
                          :disabled="!!$store.state.user.punchOutTime"
                          @click.native="punchOut">下班
        </el-dropdown-item>
        <el-dropdown-item v-else @click.native="punchIn">上班</el-dropdown-item>
        <el-dropdown-item v-group divided></el-dropdown-item>
        <el-dropdown-item v-group v-for="shop of shopList" :key="shop.id" style="display: flex; align-items: center"
                          @click.native="selectShop(shop.id)">
          <div>{{shop.name}}</div>
          <div style="flex-grow: 1"></div>
          <i class="el-icon-check" v-show="shop.id === $store.state.user.shopId"></i>
        </el-dropdown-item>
        <el-dropdown-item divided @click.native="logout">退出</el-dropdown-item>
      </el-dropdown-menu>
    </template>
  </el-dropdown>
</template>

<script>
  import { defaultAvatarUrl } from '@/utils/const'
  import { getKvList, resetAutoDispatch } from '@/utils/request'
  import { checkGroup } from '@/utils/auth-directive'

  export default {
    name: 'UserInfoDropDown',
    data () {
      return {
        defaultAvatarUrl: defaultAvatarUrl,
        shopList: []
      }
    },
    created () {
      if (checkGroup()) {
        getKvList('Shop').then(response => {
          this.shopList = response.data
        })
      }
    },
    methods: {
      async logout () {
        await this.$store.dispatch('user/logout')
        this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      },
      selectShop (shopId) {
        this.$store.commit('user/SET_SHOP_ID', shopId)
        for (const shop of this.shopList) {
          if (shop.id === shopId) {
            if (process.env.VUE_APP_CODE && shop.workshopCode !== process.env.VUE_APP_CODE) {
              const tag = '/' + process.env.VUE_APP_CODE + '/'
              const i = location.href.indexOf(tag)
              location.href = location.href.substr(0, i + 1) + shop.workshopCode + location.href.substr(i + tag.length - 1)
            }
            break
          }
        }
      },
      punchIn () {
        this.$store.dispatch('user/punchIn')
      },
      punchOut () {
        this.$store.dispatch('user/punchOut')
      },
      resetAutoDispatch () {
        // todo test
        resetAutoDispatch()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .avatar-container {
    display: flex;
    align-items: center;
  }
</style>
